import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-commenter-role',
  templateUrl: './commenter-role.component.html',
  styleUrls: ['./commenter-role.component.scss']
})
export class CommenterRoleComponent implements OnInit {

  @Input() commenterId: string;
  @Input() commentType: string;

  commenterRole: string;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    if (this.commentType === 'Approved' || this.commentType === 'Declined') {
      this.commenterRole = '- Approver -';
    } else if (this.commenterId === this.authService.getUserId()) {
      this.commenterRole = '- Initiator -';
    } else {
      this.commenterRole = ' ';
    }

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/commenter-role/commenter-role.component.ts